<template>
    <div class="login">
        <el-card>
            <img class="logo" src="/logo.png" />

            <h2>X-CUBE</h2>
            <h5>LOGIN</h5>

            <el-form class="login-form" :model="model" :rules="rules" ref="form" @submit.native.prevent="handleLogin">
                <el-form-item prop="email">
                    <el-input v-model="model.email" placeholder="E-mail" prefix-icon="fas fa-user"></el-input>
                </el-form-item>

                <el-form-item prop="password">
                    <el-input v-model="model.password" placeholder="Password" type="password"
                        prefix-icon="fas fa-lock" />
                </el-form-item>

                <el-form-item>
                    <el-button :loading="loading" :disabled="model.email.length === 0 ||
                        model.password.length === 0
                        " class="login-button" type="primary" native-type="submit" block>
                        Login
                    </el-button>
                </el-form-item>
                <div class="action-links">
                    <router-link to="/forgot-password">
                        Forgot password?
                    </router-link>
                    <router-link to="/request-login-link" class="forgot-password">
                        Request login link
                    </router-link>
                </div>
            </el-form>
        </el-card>
    </div>
</template>

<script setup>
import { Message } from "element-ui";
import { ref } from "vue";
import { useRouter } from "vue-router/composables";
import { login } from "../../api/rest";
import { isHubUser, isManagement, isOperator } from "../../helpers/auth";
import useCurrentUserStore from "../../store/userStore";

const store = useCurrentUserStore();

const router = useRouter();
const form = ref(null);

const model = ref({
    email: "",
    password: "",
});

const loading = ref(false);

const rules = {
    email: [
        {
            required: true,
            message: "Vul je e-mailadres in",
            trigger: "blur",
        },
    ],
    password: [
        {
            required: true,
            message: "Vul je wachtwoord in",
            trigger: "blur",
        },
    ],
};

const handleLogin = async () => {
    const valid = await form.value.validate();
    if (!valid) {
        return;
    }

    try {
        loading.value = true;
        const user = await login({
            identifier: model.value.email,
            password: model.value.password,
        });

        if (!isHubUser(user)) {
            window.location.replace(import.meta.env.VITE_APP_MY_XCUBE_URL);
            return;
        }

        Message.success({ message: "Login successful" });
        router.push({ name: "bookings" });
    } catch (error) {
        console.error("Login error:", error);
        Message.error({
            message: "Login failed, please check your username/password",
        });
    } finally {
        loading.value = false;
    }
};
</script>

<style scoped>
.logo {
    height: 64px;
}

.login {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-button {
    width: 100%;
    margin-top: 40px;
}

.login-form {
    width: 290px;
}

.forgot-password {
    margin-top: 10px;
}
</style>
<style lang="scss">
$teal: rgb(0, 124, 137);

.el-button--primary {
    background: $teal;
    border-color: $teal;

    &:hover,
    &.active,
    &:focus {
        background: lighten($teal, 7);
        border-color: lighten($teal, 7);
    }
}

.login .el-input__inner:hover {
    border-color: $teal;
}

.login .el-input__prefix {
    background: rgb(238, 237, 234);
    left: 0;
    height: calc(100% - 2px);
    left: 1px;
    top: 1px;
    border-radius: 3px;

    .el-input__icon {
        width: 30px;
    }
}

.login .el-input input {
    padding-left: 35px;
    font: inherit;
}

.login .el-card {
    padding-top: 0;
    padding-bottom: 30px;
}

h2 {
    // font-family: "Open Sans";
    letter-spacing: 1px;
    font-family: "Bungee", display;
    padding-bottom: 20px;
}

a {
    color: $teal;
    text-decoration: none;

    &:hover,
    &:active,
    &:focus {
        color: lighten($teal, 7);
    }
}

.login .el-card {
    width: 340px;
    display: flex;
    justify-content: center;
}

.action-links {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
